/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TenantEmailDiscoveryResponse = {
  login_url: string | null;
  post_discovery_flow: TenantEmailDiscoveryResponse.post_discovery_flow;
  firm_name: string | null;
  firm_logo_url: string | null;
  firm_icon_url: string | null;
};
export namespace TenantEmailDiscoveryResponse {
  export enum post_discovery_flow {
    SAML = 'saml',
    SAML_OR_PASSWORD = 'saml_or_password',
    PASSWORD = 'password',
  }
}

